export default __webpack_public_path__ + "static/media/scaler-text-path.1ce37914.svg";